import { Single as SingleContact } from './Single';

export default SingleContact;
